import { extractNameFromKey } from '@/utils/kayakKeys';
import { Image } from '@/components/image/Image';
import { StarRating } from '@/components/starRating/StarRating';
import getConfig from 'next/config';

import { thousandSeparated } from 'shared/util/formatting';
import type { BasicHotel, Filters } from '@/interfaces';
import { filtersToHotelPageBrowserQueryParams } from '@/utils/url/hotelPageQueryParams';
import { SearchResultItemGuestRating } from '../searchResultItemGuestRating/SearchResultItemGuestRating';
import { trackShowInfoAndOffer } from '@/utils/tracking/finnAnalytics';
import classNames from 'classnames';

const { publicRuntimeConfig } = getConfig();

export type HotelMapCardProps = BasicHotel & {
    filters: Filters;
    closeCard: () => void;
    hotelKey: string;
};
export const HotelMapCard = ({ id, hotelKey, name, starRating, guestRating, image, lowestRate, filters, closeCard }: HotelMapCardProps) => {
    const key = extractNameFromKey(hotelKey);
    const url = `${publicRuntimeConfig.basePath}/detaljer/${key}/?${filtersToHotelPageBrowserQueryParams(filters)}`;
    return (
        <article className="mapboxgl-ctrl card u-display-inline-block u-bg-milk result-list-item">
            <div className="image-container map-card-image">
                <Image altText={name} image={image?.large} frame={false} />
            </div>
            <div className={classNames('map-card-details', { 'no-rates': !lowestRate })}>
                <div>
                    <StarRating id={hotelKey} rating={starRating} emptyStars />
                    <h3 className="u-b1 two-line-ellipsis">
                        <a
                            className="link link--dark link-covering-parent"
                            data-testid="mapCardLink"
                            target="_blank"
                            rel="noopener noreferrer"
                            href={url}
                            onClick={() => trackShowInfoAndOffer(id, name)}>
                            {name}
                        </a>
                    </h3>
                </div>
                <SearchResultItemGuestRating guestRating={guestRating} numberOfReviews={0} />
            </div>
            {lowestRate && (
                <div className="map-card-price u-bg-marble u-pt8">
                    <p className="u-strong u-caption">Laveste pris</p>
                    <p data-testid="mapCardPrice" className="u-t4">
                        {thousandSeparated(Math.ceil(lowestRate))} kr
                    </p>
                </div>
            )}
            <button
                type="button"
                data-testid="closeButton"
                className="hotel-map-card-close-button button--close"
                aria-label="Lukk hotelldetaljer"
                onClick={closeCard}
            />
        </article>
    );
};
